var addAddressInit = function () {
    var additionalAddress = $('#additionalAddresses');
    $('[data-id="addAddressButton"]').on('click', function (e) {
        e.preventDefault();
        var addressURL = islington.url.addAddress,
        formdata = $(this).closest('form').serialize(),
        addressbutton = $(this);
      
        $.post(addressURL, formdata).done(function (res) {
            additionalAddress.html(res);
            var addressFinder = additionalAddress.find('.m-addressFinder:last'),
            addressInput = addressFinder.find('[data-id*=postcodefield]'),
            isOnlyCommPropertyErrorMsg = $("[data-valmsg-for=IsOnlyCommProperty]");
            addressInput.on('focus');

            if (isOnlyCommPropertyErrorMsg.hasClass("field-validation-error"))
                isOnlyCommPropertyErrorMsg.hide(); 

            //Need to add validation rules for dynamic markup
            addressInput.rules("add", {
                required: addressInput.data("val-required")==undefined?false:true,
                regex: addressInput.data("val-regex-pattern"),
                messages: {
                    required: addressInput.data("val-required"),
                    regex: addressInput.data("val-regex")
                }
            });           
            addressFinderInit();
        });
    });
};

var removeAddressInit = function (ele) {
    var removeButtons = islington.checkValidity(ele) ? ele :
    $("[data-id = removeAddressButton],[data-id = removeAddress]"),
    additionalAddress = $('#additionalAddresses');

    removeButtons.on('click', function (e) {
        e.preventDefault();
        var url = islington.url.removeAddress,
        formdata = $(this).closest('form').serialize(),
        dataId = $(this).attr('data-remove-guid'),
        data = formdata + "&id=" + dataId;

        $.post(url, data).done(function (res) {
            additionalAddress.html(res);
            addressFinderInit();
        });
    });
};
